import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { AppleIcon, Loader2Icon } from "lucide-react";
import { spring } from "../../utils/motion";
const providers = [{
  id: "google",
  label: "Google",
  glyph: <span className="text-base font-bold leading-none" data-id="element-98" data-mp="2wsncc06ch7gt">G</span>
}, {
  id: "apple",
  label: "Apple",
  glyph: <AppleIcon className="h-4 w-4" data-id="element-99" data-mp="30pjes19qlimn" />
}];
interface SocialButtonsProps {
  /** Where to land after the provider "signs in". */
  to?: string;
}
export function SocialButtons({
  to = "/app"
}: SocialButtonsProps) {
  const navigate = useNavigate();
  const [loading, setLoading] = useState<string | null>(null);
  const go = (id: string) => {
    setLoading(id);
    window.setTimeout(() => navigate(to), 900);
  };
  return <div data-id="element-100" data-mp="3ohyrj2asnd20">
      <div className="grid grid-cols-2 gap-3" data-id="element-101" data-mp="3oi8c2ad2ks0b">
        {providers.map(p => <motion.button key={p.id} type="button" onClick={() => go(p.id)} disabled={Boolean(loading)} whileTap={{
        scale: 0.97
      }} transition={spring.snappy} className="focus-ring flex items-center justify-center gap-2 rounded-xl border-3 border-line bg-surface px-3 py-2.5 text-sm font-semibold text-ink transition-colors duration-150 hover:bg-sunken disabled:opacity-60" data-id="element-102" data-mp="3tg0brqjyhif2">
            {loading === p.id ? <Loader2Icon className="h-4 w-4 animate-spin" data-id="element-103" data-mp="2rzomxsygnmlz" /> : p.glyph}
            {p.label}
          </motion.button>)}
      </div>
      <div className="my-6 flex items-center gap-3 text-xs font-semibold text-ink-2" data-id="element-104" data-mp="2n26ahsl8ip98">
        <span className="h-0.5 flex-1 bg-line/15" data-id="element-105" data-mp="2i9d9nfsw012f" />
        or with email
        <span className="h-0.5 flex-1 bg-line/15" data-id="element-106" data-mp="2dbbmaiofhfl5" />
      </div>
    </div>;
}